import React from 'react'
import { Button, Table } from 'antd'
import { Link } from 'react-router-dom'
import {
  renderOpenAnaliticPdfButton,
  renderOpenPdfButton,
} from './pdf-actions'

const CENTER_ALIGN = 'center'

const formatUpdatedAt = (updatedAt) =>
  new Date(updatedAt).toLocaleString('pt-BR', {
    timeZone: 'America/Maceio',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  })

const versionColumns = [
  { title: 'Código PCM', dataIndex: 'code', key: 'code', align: CENTER_ALIGN },
  { title: 'Versão', dataIndex: 'version', key: 'version', align: CENTER_ALIGN, width: '80px' },
  {
    title: 'Data Atualização',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    align: CENTER_ALIGN,
    render: formatUpdatedAt,
  },
  {
    title: 'PDF',
    key: 'pdf',
    align: CENTER_ALIGN,
    width: '70px',
    render: (_, version) => renderOpenPdfButton(version),
  },
  {
    title: 'PDF Analítico',
    key: 'pdfAnalitic',
    align: CENTER_ALIGN,
    width: '100px',
    render: (_, version) => renderOpenAnaliticPdfButton(version),
  },
  {
    title: 'Ações',
    key: 'edit',
    align: CENTER_ALIGN,
    width: '80px',
    render: (_, version) => (
      <Link to={`/panel/pedido-consolidado/editar/${version.objectId}`}>
        <Button icon="edit" size="small" />
      </Link>
    ),
  },
]

export const renderConsolidatedOrderVersions = (consolidatedOrder) => (
  <div style={{ margin: '-10px -5px' }}>
    <Table
      size="small"
      bordered
      pagination={false}
      dataSource={consolidatedOrder.all_versions || []}
      columns={versionColumns}
    />
  </div>
)
